import React, { useState, useRef, useEffect } from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { name: 'Surgical Scissors', href: '#products' },
      { name: 'Forceps & Clamps', href: '#products' },
      { name: 'Needle Holders', href: '#products' },
      { name: 'Retractors', href: '#products' },
      { name: 'Instrument Sets', href: '#products' }
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Mission', href: '#about' },
      { name: 'Quality Standards', href: '#about' },
      { name: 'Certifications', href: '#about' },
      { name: 'Careers', href: '#contact' }
    ],
    support: [
      { name: 'Contact Us', href: '#contact' },
      { name: 'Technical Support', href: '#contact' },
      { name: 'Product Catalog', href: '#products' },
      { name: 'Warranty Info', href: '#contact' },
      { name: 'Shipping Info', href: '#contact' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' },
      { name: 'Cookie Policy', href: '#' },
      { name: 'Compliance', href: '#' },
      { name: 'Returns Policy', href: '#' }
    ]
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: '💼', href: 'https://www.linkedin.com/company/purelifeimpex' },
    { name: 'Facebook', icon: '📘', href: 'https://www.facebook.com/purelifeimpex' }
  ];

  // Support and Legal informational content shown on click
  const supportContent = {
    'Contact Us': (
      <div>
        <p>We’re available 24/7 to assist you.</p>
        <p>
          WhatsApp: <a href="https://wa.me/923108648888" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3108648888">+92 3108648888</a>
          <br />
          Email: <a href="mailto:purelifeimpex@gmail.com" className="email-link">purelifeimpex@gmail.com</a>
          <br />
          Sales: <a href="mailto:sales@purelifeimpex.com" className="email-link">sales@purelifeimpex.com</a>
        </p>
        <p>Location: Sialkot, Punjab, Pakistan</p>
      </div>
    ),
    'Technical Support': (
      <div>
        <p>For technical assistance with instruments or orders, contact our support team 24/7.</p>
        <ul>
          <li>Email: <a href="mailto:purelifeimpex@gmail.com" className="email-link">purelifeimpex@gmail.com</a></li>
          <li>Sales: <a href="mailto:sales@purelifeimpex.com" className="email-link">sales@purelifeimpex.com</a></li>
          <li>WhatsApp: <a href="https://wa.me/923108648888" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3108648888">+92 3108648888</a></li>
          <li>Please include the instrument name, serial/lot number, and a brief description of the issue.</li>
        </ul>
      </div>
    ),
    'Product Catalog': (
      <div>
        <p>Explore our full range of products and instrument sets.</p>
        <ul>
          <li>
            Browse online: <a href="/products">Products</a>
          </li>
          <li>
            Download catalog: <a href="/Oxgen%20Surgicals.pdf" target="_blank" rel="noopener noreferrer">Purelife impex (PDF)</a>
          </li>
        </ul>
      </div>
    ),
    'Warranty Info': (
      <div>
        <p>pure;ife impex instruments are covered against manufacturing defects.</p>
        <ul>
          <li>Standard warranty: 12 months from delivery date (unless specified otherwise).</li>
          <li>Coverage: Manufacturing defects and workmanship issues.</li>
          <li>Exclusions: Misuse, improper sterilization, accidental damage, and normal wear.</li>
          <li>To claim: Contact support with proof of purchase and product details.</li>
        </ul>
      </div>
    ),
    'Shipping Info': (
      <div>
        <p>We ship worldwide with reliable carriers.</p>
        <ul>
          <li>Dispatch time: Typically 2–5 business days after order confirmation.</li>
          <li>Tracking: Provided via email once shipped.</li>
          <li>International: Customs duties and taxes are the responsibility of the receiver.</li>
        </ul>
      </div>
    )
  };

  const legalContent = {
    'Privacy Policy': (
      <div>
        <p>We respect your privacy. We collect only the necessary information to process orders and support inquiries.</p>
        <ul>
          <li>Data collected: Contact details, order information, and correspondence.</li>
          <li>Usage: Order fulfillment, customer support, and service improvements.</li>
          <li>Storage: Secured and retained only as long as necessary.</li>
          <li>Contact: For privacy requests, email purelifeimpex@gmail.com or sales@purelifeimpex.com.</li>
        </ul>
      </div>
    ),
    'Terms of Service': (
      <div>
        <p>By ordering from Purelife impex, you agree to our terms of sale and use.</p>
        <ul>
          <li>Orders: Subject to availability and confirmation.</li>
          <li>Payments: As agreed with the customer; orders may be held until payment is received.</li>
          <li>Warranty & returns: See Warranty Info and Returns Policy for details.</li>
          <li>Liability: Limited to repair or replacement as appropriate.</li>
        </ul>
      </div>
    ),
    'Cookie Policy': (
      <div>
        <p>Our website uses essential and performance cookies to improve user experience.</p>
        <ul>
          <li>Essential: Required for basic site functionality.</li>
          <li>Performance: Helps us understand usage to improve the site.</li>
          <li>Control: You may adjust cookie settings through your browser.</li>
        </ul>
      </div>
    ),
    Compliance: (
      <div>
        <p>We follow applicable international quality and safety standards.</p>
        <ul>
          <li>Manufacturing: Quality-controlled processes and materials.</li>
          <li>Documentation: Certificates provided upon request where applicable.</li>
        </ul>
      </div>
    ),
    'Returns Policy': (
      <div>
        <p>We aim for complete satisfaction with every purchase.</p>
        <ul>
          <li>Eligibility: Unused products in original condition and packaging.</li>
          <li>Process: Request an RMA via support within 30 days of delivery.</li>
          <li>Inspection: Items are inspected before refund or replacement.</li>
          <li>Fees: A restocking fee may apply depending on the item condition.</li>
        </ul>
      </div>
    )
  };

  const [selectedInfo, setSelectedInfo] = useState(null);

  const handleInfoClick = (group, name, e) => {
    if (e) e.preventDefault();
    const contentMap = group === 'support' ? supportContent : legalContent;
    const content = contentMap[name];
    if (content) {
      setSelectedInfo({ group, title: name, content });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const infoPanelRef = useRef(null);
  useEffect(() => {
    if (selectedInfo && infoPanelRef.current) {
      infoPanelRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [selectedInfo]);

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <div className="brand-logo">
                <h3>Purelife impex</h3>
                <span className="brand-tagline">Premium Medical Equipment</span>
              </div>
              <p className="brand-description">
                Leading manufacturer of high-quality surgical instruments, 
                serving healthcare professionals worldwide with precision, 
                reliability, and innovation.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.href}
                    className="social-link"
                    aria-label={social.name}
                    title={social.name}
                  >
                    <span className="social-icon">{social.icon}</span>
                  </a>
                ))}
              </div>
            </div>

            <div className="footer-links">
              <div className="link-group">
                <h4>Products</h4>
                <ul>
                  {footerLinks.products.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Company</h4>
                <ul>
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <a href={link.href}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Support</h4>
                <ul>
                  {footerLinks.support.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} onClick={(e) => handleInfoClick('support', link.name, e)}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4>Legal</h4>
                <ul>
                  {footerLinks.legal.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} onClick={(e) => handleInfoClick('legal', link.name, e)}>{link.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="footer-contact">
              <h4>Get In Touch</h4>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <div>
                  <p>Sialkot</p>
                  <p>Punjab</p>
                  <p>Pakistan</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <div>
                  <p className="contact-phone-row">
                    <a href="https://wa.me/923108648888" className="whatsapp-link" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp +92 3108648888">WhatsApp: +92 3108648888</a>
                  </p>
                  <p>Available 24/7</p>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div>
                  <p>
                    <a href="mailto:purelifeimpex@gmail.com" className="email-link">purelifeimpex@gmail.com</a>
                    <br />
                    <a href="mailto:sales@purelifeimpex.com" className="email-link">sales@purelifeimpex.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          {selectedInfo && (
            <div className="footer-info-panel" role="region" aria-live="polite" aria-label={`${selectedInfo.group} information`} ref={infoPanelRef}>
              <div className="info-header">
                <h4 className="info-title">{selectedInfo.title}</h4>
                <button className="info-close" onClick={() => setSelectedInfo(null)} aria-label="Close information">×</button>
              </div>
              <div className="info-content">{selectedInfo.content}</div>
            </div>
          )}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; {currentYear} Purelife impex. All rights reserved.</p>
            </div>
            <div className="footer-bottom-links">
              <a href="#" onClick={(e) => handleInfoClick('legal', 'Privacy Policy', e)}>Privacy Policy</a>
              <a href="#" onClick={(e) => handleInfoClick('legal', 'Terms of Service', e)}>Terms of Service</a>
            </div>
            <button 
               className="back-to-top"
               onClick={scrollToTop}
               aria-label="Back to top"
             >
               <span className="back-to-top-icon">↑</span>
             </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;